import moment from 'moment';
import Vue from 'vue';

// ===========================================================================
//  FILTERS
// ==========================================================================

Vue.filter('formatDate', (value, format = 'DD/MM/YYYY') => {
  if (value) {
    return moment(value).format(format);
  }
  return '';
});

Vue.filter('formatDateBackend', (value, format = 'YYYY-MM-DD') => {
  if (value) {
    return moment(value).format(format);
  }
  return '';
});

Vue.filter('formatDateLocal', (value, format = 'YYYY-MM-DD[T]HH:mm:ss') => {
  if (value) {
    return moment(value).format(format);
  }
  return '';
});

Vue.filter('formatDateLongMonth', (value, format = 'DD MMMM YYYY') => {
  if (value) {
    return moment(value).locale(Vue.config.language).format(format);
  }
  return '';
});
